import { Component } from '@angular/core';
import { TruncatedContentCustomTooltipComponent } from '../truncated-content-tooltip-cell-renderer/truncated-content-custom-tooltip/truncated-content-custom-tooltip.component';
import { TooltipDirective } from 'shared/directives/tooltip.directive';

@Component({
    selector: 'app-generic-cell-with-tooltip-renderer',
    imports: [TooltipDirective],
    templateUrl: './generic-cell-with-tooltip-renderer.component.html',
    styleUrl: './generic-cell-with-tooltip-renderer.component.scss',
})
export class GenericCellWithTooltipRendererComponent {
    public fullText: string = '';

    agInit(params: any): void {
        this.fullText = params.value != null ? String(params.value) : '';
    }

    truncatedContentCustomTooltipComponent = TruncatedContentCustomTooltipComponent;

    refresh(params: any): boolean {
        this.fullText = params.value != null ? String(params.value) : '';
        return true;
    }
}
